import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@sitemule/ng-components/directives/navigation';
import { NavigationDirectiveModule } from '@sitemule/ng-components/directives/navigation';
import { RouterModule } from '@angular/router';

const isActive = (item, activeUrl) => {
    var _a;
    return (item.url === activeUrl || !!((_a = item.items) === null || _a === void 0 ? void 0 : _a.some((i) => isActive(i, activeUrl))));
};
const getAllActiveIds = (items, ac) => {
    const ids = [];
    items.forEach(item => {
        const activeInItems = getAllActiveIds(item.items || [], ac);
        if (activeInItems.length) {
            [...activeInItems, item.id].forEach(x => ids.push(x));
        }
        else if (item.url === ac) {
            ids.push(item.id);
        }
    });
    return ids;
};
class NavigationComponent {
    constructor() {
        this._activeUrl = '';
        this._items = [];
        this.formattedItems$ = new BehaviorSubject([]);
        this.expandedItemIds = new Set();
    }
    set activeUrl(activeUrl) {
        this._activeUrl = activeUrl || '';
        this.addInitialActiveUrlIdIntoExpandedList();
    }
    get activeUrl() {
        return this._activeUrl;
    }
    set items(items) {
        this._items = items || [];
        this.addInitialActiveUrlIdIntoExpandedList();
    }
    get items() {
        return this._items;
    }
    addInitialActiveUrlIdIntoExpandedList() {
        getAllActiveIds(this.items, this.activeUrl).forEach(id => this.expandedItemIds.add(id));
        this.calculateFormattedMenuItems();
    }
    getFormattedMenuItems() {
        const menuItemMapper = (item) => {
            var _a;
            const active = isActive(item, this.activeUrl);
            return Object.assign(Object.assign({}, item), { url: item.url, isActive: active, expanded: this.expandedItemIds.has(item.id), items: (_a = item.items) === null || _a === void 0 ? void 0 : _a.map(item => menuItemMapper(item)) });
        };
        return this.items.map(menuItemMapper);
    }
    calculateFormattedMenuItems() {
        this.formattedItems$.next(this.getFormattedMenuItems());
    }
    onClick(clickedItem) {
        var _a;
        // Item should have some children items to be expanded/collapsed
        if ((_a = clickedItem.items) === null || _a === void 0 ? void 0 : _a.length) {
            const isExpanded = this.expandedItemIds.has(clickedItem.id);
            if (isExpanded) {
                this.expandedItemIds.delete(clickedItem.id);
            }
            else {
                this.expandedItemIds.add(clickedItem.id);
            }
            this.calculateFormattedMenuItems();
        }
        ;
    }
}
NavigationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: NavigationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NavigationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.6", type: NavigationComponent, selector: "sm-navigation", inputs: { activeUrl: "activeUrl", items: "items" }, ngImport: i0, template: "<ng-template #nestedItems let-items>\n  <div *ngFor=\"let item of items\" class=\"navigation__item\" [class.navigation__item__active]=\"item.isActive\" [class.navigation__item__expanded]=\"item.expanded\">\n    <a *ngIf=\"item.url\" [smNavigate]=\"item.url\" [smNavigateTarget]=\"item.target\" class=\"navigation__link\">{{item.title}}</a>\n    <div *ngIf=\"!item.url\" class=\"navigation__link\" (click)=\"onClick(item)\">{{item.title}}</div>\n    <div *ngIf=\"item.items && item.items.length\" class=\"navigation__inner__items\">\n      <ng-container *ngTemplateOutlet=\"nestedItems; context: {$implicit: item.items}\"></ng-container>\n    </div>\n  </div>\n</ng-template>\n<ng-container *ngIf=\"formattedItems$ | async as items\">\n  <ng-container *ngTemplateOutlet=\"nestedItems; context: {$implicit: items}\"></ng-container>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.NavigationDirective, selector: "[smNavigate]", inputs: ["smNavigate", "smNavigateTarget"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: NavigationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sm-navigation', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-template #nestedItems let-items>\n  <div *ngFor=\"let item of items\" class=\"navigation__item\" [class.navigation__item__active]=\"item.isActive\" [class.navigation__item__expanded]=\"item.expanded\">\n    <a *ngIf=\"item.url\" [smNavigate]=\"item.url\" [smNavigateTarget]=\"item.target\" class=\"navigation__link\">{{item.title}}</a>\n    <div *ngIf=\"!item.url\" class=\"navigation__link\" (click)=\"onClick(item)\">{{item.title}}</div>\n    <div *ngIf=\"item.items && item.items.length\" class=\"navigation__inner__items\">\n      <ng-container *ngTemplateOutlet=\"nestedItems; context: {$implicit: item.items}\"></ng-container>\n    </div>\n  </div>\n</ng-template>\n<ng-container *ngIf=\"formattedItems$ | async as items\">\n  <ng-container *ngTemplateOutlet=\"nestedItems; context: {$implicit: items}\"></ng-container>\n</ng-container>\n" }]
        }], propDecorators: { activeUrl: [{
                type: Input
            }], items: [{
                type: Input
            }] } });

class NavigationComponentModule {
}
NavigationComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: NavigationComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NavigationComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: NavigationComponentModule, declarations: [NavigationComponent], imports: [CommonModule,
        RouterModule,
        NavigationDirectiveModule], exports: [NavigationComponent] });
NavigationComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: NavigationComponentModule, imports: [CommonModule,
        RouterModule,
        NavigationDirectiveModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: NavigationComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NavigationComponent],
                    imports: [
                        CommonModule,
                        RouterModule,
                        NavigationDirectiveModule,
                    ],
                    exports: [NavigationComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { NavigationComponent, NavigationComponentModule };
